/* unplugin-vue-components disabled */import { render } from "./TicketsGrid.vue?vue&type=template&id=0dc4233f&ts=true"
import script from "./TicketsGrid.vue?vue&type=script&lang=ts"
export * from "./TicketsGrid.vue?vue&type=script&lang=ts"

import "./TicketsGrid.vue?vue&type=style&index=0&id=0dc4233f&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__